<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      d="M11.5449 48.0977C12.2451 48.0977 12.8125 48.665 12.8125 49.3652C12.8124 50.0654 12.2451 50.6328 11.5449 50.6328C10.8448 50.6327 10.2774 50.0653 10.2773 49.3652C10.2773 48.6651 10.8448 48.0977 11.5449 48.0977ZM35.0908 3.54102C47.5947 3.54102 57.7314 13.6777 57.7314 26.1816C57.7313 38.6854 47.5946 48.8213 35.0908 48.8213C22.5871 48.8212 12.4503 38.6854 12.4502 26.1816C12.4502 13.6778 22.587 3.54109 35.0908 3.54102ZM65.8818 7.8877C67.9824 7.88773 69.6854 9.59086 69.6855 11.6914C69.6855 13.792 67.9825 15.4951 65.8818 15.4951C63.7812 15.4951 62.0781 13.7921 62.0781 11.6914C62.0782 9.59084 63.7812 7.8877 65.8818 7.8877ZM53.9277 1.36719C55.0281 1.36721 55.9199 2.26002 55.9199 3.36035C55.9197 4.4605 55.0279 5.35252 53.9277 5.35254C52.8275 5.35254 51.9358 4.46052 51.9355 3.36035C51.9355 2.26001 52.8274 1.36719 53.9277 1.36719Z"
      fill="url(#paint0_radial_410_32619)"
    />
    <path
      d="M18.4941 20.9401C18.1587 20.121 18.5519 19.1846 19.3725 18.8485L37.5736 11.394C38.3942 11.058 39.3313 11.4495 39.6668 12.2686L48.93 34.886C49.2655 35.7051 48.8722 36.6416 48.0517 36.9777L29.8506 44.4321C29.03 44.7682 28.0928 44.3766 27.7574 43.5575L18.4941 20.9401Z"
      fill="url(#paint1_radial_410_32619)"
    />
    <path
      d="M22.582 14.4738C22.582 13.5886 23.3009 12.8711 24.1876 12.8711H43.8561C44.7428 12.8711 45.4616 13.5886 45.4616 14.4738V38.9146C45.4616 39.7997 44.7428 40.5173 43.8561 40.5173H24.1876C23.3009 40.5173 22.582 39.7997 22.582 38.9146V14.4738Z"
      fill="url(#paint2_radial_410_32619)"
    />
    <path
      d="M29.493 38.0912C30.2366 37.0845 31.2291 35.5297 31.6738 33.8155C31.8815 33.0135 31.9179 32.3767 31.5625 31.9046C31.5191 31.8473 31.1769 31.392 30.7506 31.4191C29.8979 31.4735 29.1307 33.4335 29.2705 35.1624C29.3252 35.8402 29.3853 36.5787 29.9356 37.0168C31.0819 37.9299 33.6158 36.993 34.3059 35.4914C34.3524 35.3905 34.7813 34.4143 34.3164 33.925C34.075 33.6706 33.6351 33.593 33.3139 33.7215C32.5585 34.0233 32.2588 35.5409 32.8683 36.4938C33.0045 36.7068 33.2552 37.0965 33.6802 37.1672C34.7274 37.3414 35.7151 35.3711 36.1471 35.5853C36.438 35.7298 36.1857 36.6559 36.4337 36.7288C36.5971 36.7766 36.7194 36.3765 37.3091 35.9768C37.7232 35.6961 38.0952 35.6004 38.2324 35.5698C38.4558 35.5194 38.6486 35.5077 38.7871 35.5073"
      stroke="url(#paint3_radial_410_32619)"
      stroke-width="0.635545"
      stroke-miterlimit="10"
    />
    <rect
      x="24.4883"
      y="17.002"
      width="9.53317"
      height="1.58886"
      rx="0.635545"
      fill="url(#paint4_radial_410_32619)"
    />
    <rect
      x="24.4883"
      y="19.5449"
      width="4.76658"
      height="1.58886"
      rx="0.635545"
      fill="url(#paint5_radial_410_32619)"
    />
    <rect
      x="24.4883"
      y="23.041"
      width="19.3841"
      height="1.58886"
      rx="0.635545"
      fill="url(#paint6_radial_410_32619)"
    />
    <rect
      x="24.4883"
      y="26.0156"
      width="13.982"
      height="1.58886"
      rx="0.635545"
      fill="url(#paint7_radial_410_32619)"
    />
    <g opacity="0.5" filter="url(#filter0_f_410_32619)">
      <path
        d="M49.1786 15.2524C49.492 14.7096 50.1861 14.5236 50.729 14.837C51.2718 15.1504 51.4578 15.8445 51.1444 16.3874L42.079 32.0892C42.0334 32.1681 41.9794 32.242 41.918 32.3094L39.4086 35.0655C39.1789 35.3177 38.7672 35.08 38.8708 34.755L40.0029 31.2037C40.0306 31.1168 40.0676 31.0332 40.1132 30.9542L49.1786 15.2524Z"
        fill="url(#paint8_radial_410_32619)"
      />
    </g>
    <path
      d="M47.5984 13.7486C48.0813 12.9123 49.1506 12.6258 49.9869 13.1086C50.8231 13.5914 51.1097 14.6608 50.6268 15.497L41.4956 31.3128C41.4293 31.4277 41.3454 31.5315 41.247 31.6204L37.9045 34.6407C37.6756 34.8475 37.3161 34.6399 37.3807 34.3383L38.3251 29.9335C38.3529 29.8038 38.4009 29.6793 38.4672 29.5644L47.5984 13.7486Z"
      fill="url(#paint9_radial_410_32619)"
    />
    <path
      d="M47.5984 13.7486C48.0813 12.9123 49.1506 12.6258 49.9869 13.1086C50.8231 13.5914 51.1097 14.6608 50.6268 15.497L41.576 31.1736L38.5475 29.4252L47.5984 13.7486Z"
      fill="url(#paint10_linear_410_32619)"
    />
    <defs>
      <filter
        id="filter0_f_410_32619"
        x="37.5844"
        y="13.4145"
        width="14.9836"
        height="23.0285"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.635545"
          result="effect1_foregroundBlur_410_32619"
        />
      </filter>
      <radialGradient
        id="paint0_radial_410_32619"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(59.5735 -11.6281) rotate(117.322) scale(76.1914 80.099)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_410_32619"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.772 31.0929) rotate(-112.272) scale(18.0592 24.5759)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_410_32619"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(51.0227 47.0316) rotate(-129.519) scale(44.6948 48.9434)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_410_32619"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(37.1644 29.6577) rotate(121.468) scale(10.7501 12.3397)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_410_32619"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.426 17.7158) rotate(4.3184) scale(12.5381 2.54869)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_410_32619"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.9571 20.2588) rotate(8.58828) scale(6.32215 2.52729)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_410_32619"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(26.3949 23.7549) rotate(2.12685) scale(25.4393 2.55419)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_410_32619"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.8636 26.7295) rotate(2.94735) scale(18.3613 2.55257)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_410_32619"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(46.3661 22.4232) rotate(119.929) scale(47.5485 4.32755)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_410_32619"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.6625 44.0324) rotate(-62.9665) scale(40.9511 9.75217)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <linearGradient
        id="paint10_linear_410_32619"
        x1="38.9395"
        y1="32.0951"
        x2="36.5379"
        y2="30.3641"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </linearGradient>
    </defs>
  </svg>
</template>
